/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeTemplates {
  angular.module("meevo.plugins.employeeTemplates", []);
}